import { Box } from "@mui/material";
import { useVirtualizer } from "@tanstack/react-virtual";
import { Children, forwardRef, useImperativeHandle, useRef } from "react";

export const VirtualizedListboxComponent = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLElement>
>(function VirtualizedListboxComponent(props, ref) {
  const { children, ...other } = props;
  const items = Children.toArray(children);
  const parentRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => parentRef.current as HTMLDivElement, []);

  // eslint-disable-next-line react-hooks/incompatible-library
  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 36,
    overscan: 5,
  });

  return (
    <Box
      ref={parentRef}
      sx={{
        height: Math.min(8, items.length) * 48,
        overflow: "auto",
      }}
      {...other}
    >
      <Box
        sx={{
          height: virtualizer.getTotalSize(),
          width: "100%",
          position: "relative",
        }}
      >
        {virtualizer.getVirtualItems().map((virtualRow) => {
          const item = items[virtualRow.index] as React.ReactElement;
          return (
            <Box
              key={virtualRow.key}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                transform: `translateY(${virtualRow.start}px)`,
              }}
            >
              {item}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
});
